module.exports = __webpack_public_path__ + "static/img/testimonial-2.a018c450.jpg";